/** @jsx jsx */
import { jsx, css, useTheme } from "@emotion/react";
import { useLocation } from "@gatsbyjs/reach-router";
import usePageTree from "@whitespace/gatsby-theme-wordpress-basic/src/hooks/usePageTree";

import TreeMenu from "../../../../wsui/components/TreeMenu.jsx";

export default function HeaderHamburgerMenuPanel({ ...restProps }) {
  const theme = useTheme();
  const location = useLocation();
  const { pathname } = location;

  const items = usePageTree(
    {
      transform: ({ uri, ...item }, children) => ({
        ...item,
        href: uri,
        items: children,
        current: uri === pathname,
      }),
      includeFrontPage: true,
    },
    [pathname],
  );

  return (
    <TreeMenu
      items={items || []}
      css={css`
        padding-top: ${theme.getLength(5)};
        padding-bottom: ${theme.getLength(7)};
      `}
      {...restProps}
    />
  );
}
